import { useSidebarData } from '@/hooks/useSidebarData';
import type { SidebarCategory } from '@/data/types';

export function Sidebar() {
  const { sidebarData } = useSidebarData();

  const handleLinkClick = (href: string, external?: boolean) => {
    if (external) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      // For internal links, we'll just update the href for now
      // In a full implementation, this would integrate with router
      window.location.href = href;
    }
  };

  const renderCategory = (category: SidebarCategory) => {
    const baseClasses = "block w-full text-left py-2 px-1 text-sm transition-colors duration-200 hover:bg-gray-50";
    
    let textClasses = "text-[#022762] hover:text-[#315394]";
    
    if (category.featured) {
      textClasses = "text-[#315394] font-medium hover:text-[#022762]";
    } else if (category.special) {
      textClasses = "text-[#e58231] font-medium hover:text-[#fe8b39]";
    }

    return (
      <button
        key={category.name}
        className={`${baseClasses} ${textClasses}`}
        onClick={() => handleLinkClick(category.href, category.external)}
        type="button"
      >
        {category.name}
      </button>
    );
  };

  return (
    <aside className="w-64 bg-white border-r border-gray-200 min-h-screen">
      <nav className="p-4 space-y-1">
        {sidebarData.categories.map(renderCategory)}
      </nav>
    </aside>
  );
}